import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";

import css from "./PeriodComponent.module.css";
import {periodsActions} from "../../../store/slices/settings-slices";
import {periodsService} from "../../../services/settings-services";
import {ButtonDelete, ButtonUpdate, ModalForDelete} from "../../../ui";
import {PeriodsUpdatePeriodModal} from "../settingSectionModals/PeriodsUpdatePeriodModal/PeriodsUpdatePeriodModal";


const PeriodComponent = ({period}) => {
    const dispatch = useDispatch();
    const [isOpenUpdate, setIsOpenUpdate] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

   const {id, daysCount, discount, isDefault} = period;

    const handleDeleteClick = async () => {
        try {
            await periodsService.deleteById(id);
            dispatch(periodsActions.changeTrigger());
            toast.success("Period successfully deleted!");
        } catch (error) {
            toast.error("Error deleting period.");
        }
    };

    const handleUpdateClick = () => {
        setIsOpenUpdate(true);
    };


    return (
        <>
            <tr className={css.wrap}>
                <td className={css.daysCount}>{daysCount}</td>

                <td className={css.discount}>{discount}%</td>

                <td>
                    <input type="checkbox" checked={isDefault} readOnly/>
                </td>

                <td className={css.btn}>
                    <ButtonUpdate onClick={handleUpdateClick}/>
                    <ButtonDelete onClick={() => setIsOpenDeleteModal(true)}/>
                </td>
            </tr>

            {isOpenUpdate && <PeriodsUpdatePeriodModal
                setIsOpenUpdate={setIsOpenUpdate}
                period={period}
            />
            }

            {isOpenDeleteModal && (
                <ModalForDelete
                    handleDeleteClick={handleDeleteClick}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    name={"period"}
                />
            )}
        </>
    );
};

export default React.memo(PeriodComponent);
